import { render, staticRenderFns } from "./RingTimer.vue?vue&type=template&id=5247c33c&scoped=true&"
import script from "./RingTimer.vue?vue&type=script&lang=js&"
export * from "./RingTimer.vue?vue&type=script&lang=js&"
import style0 from "./RingTimer.vue?vue&type=style&index=0&id=5247c33c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5247c33c",
  null
  
)

export default component.exports